import { Link } from "react-router-dom";
import ContentPage from "../../../Content";
import { useState } from "react";
import SwalTopEnd from "../../../../utils/swal_top_end";
import axios from "axios";
import BaseUrl from "../../../../utils/BaseUrl";

const url = BaseUrl();
function AddDistributeurForms(){

  const [errors,setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error,setError] = useState();

  const [itemsData,setItemsData] = useState({
    'raison_social':'',
    'adresse':'',
    'email':'',
    'phone':'',
    'gerant':'',
    'description':'',
});

const handleChange=(e)=>{
  setItemsData({
      ...itemsData,
      [e.target.name]:e.target.value
  });
}

const submitForm= async(e)=>{
  e.preventDefault();
  const _formData = new FormData();
  _formData.append("raison_social",itemsData.raison_social);
  _formData.append("email",itemsData.email);
  _formData.append("phone",itemsData.phone);
  _formData.append("gerant",itemsData.gerant);
  _formData.append("description",itemsData.description);

  console.log(_formData);
  setLoading(true);

  try {
    axios.post(url.base+'/distributeurs-store',_formData,
   {
       headers:{
           'Content-Type':'multipart/form-data',
           "Authorization": `Bearer ${localStorage.getItem('_token_')}`
           
       },
       credentials:'include'
   }
   ).then((resp)=>{          
       setLoading(false);     
        SwalTopEnd({icon:"success",title:"Opération effectuée avec succès !"});
        // navigate('/interventions-list');
        setErrors({});    
    }).catch((error)=>{
       setLoading(false);
       console.log(error.response.status);
       if(error.response.status == 500)
       {
        SwalTopEnd({icon:"error",title:"Un problème est subvenu !"});
       }
       setError(error.response.data.message);
       setErrors(error.response.data.error);

   })
} catch (error) {
setLoading(false);
   console.log(error.response);
} 


}


    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Formulaire de création d'un distributeur</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              <div class="header-left">
                <Link class="btn btn-warning mb-2 mb-md-0 mr-2" to="/parametres/distributeurs"><i class="mdi mdi-backburger"></i> Retour à la liste</Link>
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Nouveau distributeur</h4>
                    <p class="card-description">Tous les champs sont obligatoires</p>
                    <form class="forms-sample" onSubmit={submitForm}>
                      <div class="form-group">
                        <label for="exampleInputName1">Raison sociale</label>
                        <input type="text" class="form-control"  placeholder="Raison sociale" onChange={handleChange} name="raison_social" />
                        {errors && errors.raison_social && (
                            <span className="text-danger">{errors.raison_social[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail3">Adresse email</label>
                        <input type="email" class="form-control" placeholder="Email" onChange={handleChange} name="email"/>
                        {errors && errors.email && (
                            <span className="text-danger">{errors.email[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword4">Numéro de téléphone</label>
                        <input type="text" class="form-control"  placeholder="Numéro de téléphone" onChange={handleChange} name="phone"/>
                        {errors && errors.phone && (
                            <span className="text-danger">{errors.phone[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleInputCity1">Nom du gérant</label>
                        <input type="text" class="form-control" placeholder="Nom du gerant" onChange={handleChange} name="gerant" />
                        {errors && errors.gerant && (
                            <span className="text-danger">{errors.gerant[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Description</label>
                        <textarea
                          class="form-control"
                          rows="4"
                          name="description"
                          onChange={handleChange}
                        ></textarea>
                        {errors && errors.description && (
                            <span className="text-danger">{errors.description[0]}</span>
                        )}
                      </div>
                      {!loading &&<button type="submit" class="btn btn-primary mr-2"> Enregistrer les informations </button>}
                      {loading && <button className="btn btn-primary " type="button" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Chargement...
                      </button>}
                    </form>
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}

export default AddDistributeurForms;